export const INCOME_TIER_NONE = 'income-tier-none';

export const FIELD_NAMES = {
  AGE: 'age',
  FREQUENCY: 'frequency',
  HOSPITAL_EXCESS: 'hospitalExcess',
  INCOME_TIER: 'incomeTier',
  INCOME_TYPE: 'incomeType',
  PARTNER_AGE: 'partnerAge',
  REBATE: 'rebate',
  SCALE: 'scale',
  STATE: 'state',
} as const;
